export const inputDefaultDesign = "py-4 px-5 w-full bg-white border-2 rounded-lg ";
export const inputReadonlyDesign = "py-4 px-5 w-full bg-gray-100 border-2 rounded-lg text-gray-400"
